import {I18N_EN_US, I18N_PT_PT} from 'lf-at-theme';
import {LfI18n} from '@lightweightform/core';

import {appI18NPtPT} from './__i18n__/app.i18n.pt-PT';
import {appI18NEnUS} from './__i18n__/app.i18n.en-US';
import {unionFormI18nPtPT} from './union-form/__i18n__/union-form.i18n.pt-PT';
import {unionFormI18nEnUS} from './union-form/__i18n__/union-form.i18n.en-US';
import {
  sharedI18n_EN_US, sharedI18n_PT_PT,
  sharedAppI18n_EN_US, sharedAppI18n_PT_PT
} from '../shared';

const {sharedFormI18nPtPT} = sharedI18n_PT_PT;
const {sharedFormI18nEnUS} = sharedI18n_EN_US;
const {sharedAppI18nPtPT} = sharedAppI18n_PT_PT;
const {sharedAppI18nEnUS} = sharedAppI18n_EN_US;

/**
 * App i18n object.
 */
export const I18N_UNION: Record<string, any> = {
  'pt-PT': LfI18n.mergeTranslations(
    I18N_PT_PT,
    sharedAppI18nPtPT,
    appI18NPtPT,
    sharedFormI18nPtPT(true),
    unionFormI18nPtPT,
  ),
  'en-US': LfI18n.mergeTranslations(
    I18N_EN_US,
    sharedAppI18nEnUS,
    appI18NEnUS,
    sharedFormI18nEnUS(true),
    unionFormI18nEnUS,
  ),
};
